import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import BranchTicketsPerService from "../../../components/branches/reports/daily/BranchTicketsPerService";
import {
  TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const asArray = (data) => (Array.isArray(data) ? data : [data]);

const DailyBranchTicketsPerService = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
    descriptionKey="TicketsPerServiceBranches"
    normalizeData={asArray}
    title={`${reportIndex}. Tickets Per Service`}
  >
    {({ data, renderConfig }) => (
      data.map((branch, index) => (
          <BranchTicketsPerService
            key={index}
            branchId={branch.branchId}
            reportIndex={reportIndex}
            branchIndex={index + 1}
            data={branch.serviceData}
            numServices={branch.numServices}
            branchName={branch.branchName}
            renderConfig={renderConfig}
          />
        ))
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchTicketsPerService;
